import { takeLatest, put } from 'redux-saga/effects';
import { actions } from '../slices/VehicleReportSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import { call } from 'redux-saga/effects';



function* getVehicleReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('vehicle_report')}`, {
            params: {
                ...filters,
                page: filters.page - 1
            }
        });
        yield put({ type: actions.get_vehicle_report_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_vehicle_report_failed.type, payload: error });
    }
}

function* exportVehicleReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('vehicle_report')}`, {
            params: {
                ...filters,
                export: true,
                page: filters.page - 1
            }
        });
        NotificationHandler.notifyDownloadBox(response.data);
        const action = { filters };
        yield call(getVehicleReport, { payload: action });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.get_vehicle_report_failed.type, payload: error });
    }
}


function* watchRequestDetail() {
    yield takeLatest(actions.get_vehicle_report.type, getVehicleReport);
    yield takeLatest(actions.export_vehicle_report.type, exportVehicleReport);
}

export default watchRequestDetail;